module.exports = __webpack_public_path__ + "img/pencil.7fd9810c.svg";